import {portrait} from './shared.js';
import {enable as enableTicker, disable as disableTicker, queueTicker, onTickerComplete} from './ticker.js';

const transitioner = document.querySelector('#transitioner');
const threshold = window.innerHeight;

let transitionPromise = Promise.resolve();

let transitioning = false;

let trailerTimer = null;

/**
 * Setup transitioner
 */
export function setupTransitioner() {
  console.log('transitioner:setupTransitioner');

  let delta = 0;

  const main = document.querySelector('main');

  window.addEventListener('scroll', () => {
    if (!document.body.classList.contains('intro-done')) {
      return;
    }

    if (!portrait.matches) {
      return;
    }
    const height = (document.documentElement.scrollHeight || document.body.scrollHeight) - window.innerHeight;

    if (window.pageYOffset < height) {
      clearTimeout(trailerTimer);
      trailerTimer = null;
    } else {
      trailerTimer = setTimeout(() => {
        transitionPromise = transitionPromise.then(() => transition(+1)); // +1 - positive number - transition to beginning
      }, 1500);
    }
  }, {passive: true});

  window.addEventListener('wheel', ({deltaY}) => {
    if (!document.body.classList.contains('intro-done')) {
      return;
    }

    if (portrait.matches) {
      return;
    }

    if (transitioning) {
      return;
    }

    if (window.pageYOffset <= main.offsetTop || window.pageYOffset + window.innerHeight >= main.offsetTop + main.scrollHeight) {
      delta += Math.abs(deltaY);
      if (delta >= threshold) {
        const direction = delta;
        delta = 0;
        transitioning = true;
        transitionPromise = transitionPromise.then(() => transition(direction));
      }
    } else {
      delta = 0;
    }
  }, {passive: true});
}

/**
 * Show transition overlay, then transition from beginning to end
 * @param {Number} direction +/- indicates direction of transition (top-to-bottom or v.v.)
 * @return {Promise} resolves when transition finishes
 */
function transition(direction) {
  console.log(direction);
  const ticker = document.querySelector('.ticker');
  transitioner.classList.add('top');
  transitioner.classList.add('show');

  return new Promise(resolve => {
    transitioner.addEventListener('transitionend', () => {
      ticker.classList.add('fast');

      let sectionOffset;

      if (window.pageYOffset === 0) {
        const article = document.querySelector('article:nth-last-of-type(1)');
        sectionOffset = article.offsetTop + article.scrollHeight;
      } else {
        const article = document.querySelector('article:nth-of-type(1)');
        sectionOffset = article.offsetTop + 60;
      }

      TweenLite.set(window, {
        scrollTo: sectionOffset,
        onComplete: () => {
          setTimeout(() => {
            onTickerComplete(() => {
              ticker.classList.remove('fast');
              transitioner.classList.remove('show');
              transitioner.addEventListener('transitionend', () => {
                transitioner.classList.remove('top');
                transitioning = false;
                resolve();
              }, {once: true});
            });
          }, 1000);
        },
      });
    }, {once: true});
  });
}
